/* eslint-disable no-undefined */
import React from "react";
import PropTypes from "prop-types";
import { endOfDay, startOfDay } from "date-fns";
//Date Picker
import { DateRangePicker as DRP } from "react-date-range";
import enGb from "react-date-range/dist/locale/en-GB";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import { REPORTING_DAILY_STATIC_RANGES, getDefinedDates } from "./StaticDateRanges";
import SingleDatePicker from "./SingleDatePicker";
const useStyles = makeStyles(theme => ({
  dateRangePickerContainer: {
    fontFamily: theme.typography.fontFamily
  }
}));
const DateRangePicker = ({
  onDateRangeChange,
  selectionRange,
  minDate,
  maxDate,
  staticRanges,
  infiniteEndDate,
  isSingleRangeSelector
}) => {
  React.useEffect(() => {
    onDateRangeChange(selectionRange);
  }, []);
  const classes = useStyles();
  if (isSingleRangeSelector) {
    return /*#__PURE__*/React.createElement(SingleDatePicker, {
      classes: classes,
      onChange: onDateRangeChange,
      selectionRange: selectionRange,
      minDate: minDate,
      maxDate: maxDate,
      infiniteEndDate: infiniteEndDate
    });
  }
  const handleSelect = ({
    selection
  }) => {
    selection.startDate = startOfDay(selection.startDate);
    if (isSingleRangeSelector) {
      selection.endDate = endOfDay(selection.startDate);
    } else {
      selection.endDate = endOfDay(selection.endDate);
    }
    onDateRangeChange(selection);
  };
  if (!selectionRange.key) {
    selectionRange.key = "selection";
    selectionRange.color = "rgba(0,79,265,0.8)";
  }
  return /*#__PURE__*/React.createElement(DRP, {
    className: classes.dateRangePickerContainer,
    ranges: [selectionRange],
    onChange: handleSelect,
    minDate: minDate,
    maxDate: infiniteEndDate ? undefined : maxDate,
    inputRanges: [],
    staticRanges: isSingleRangeSelector ? [] : staticRanges,
    locale: enGb,
    disablePassive: true
  });
};
export default DateRangePicker;
DateRangePicker.propTypes = {
  onDateRangeChange: PropTypes.func.isRequired,
  selectionRange: PropTypes.object,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  staticRanges: PropTypes.array,
  infiniteEndDate: PropTypes.bool,
  isSingleRangeSelector: PropTypes.bool
};
DateRangePicker.defaultProps = {
  selectionRange: {
    startDate: getDefinedDates().startOfYesterday,
    endDate: getDefinedDates().endOfToday,
    key: "selection",
    color: "rgba(0,79,265,0.8)"
  },
  minDate: getDefinedDates().limitlessStartDate,
  maxDate: getDefinedDates().endOfToday,
  staticRanges: REPORTING_DAILY_STATIC_RANGES,
  infiniteEndDate: false,
  isSingleRangeSelector: false
};